//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      dynamicValimarkForm: {
        remarks: "",
        orderId: "",
      },
      stepLoading: false,
      dialogVisible_remark: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_remark = this.openStatus;
    },
    orderId(val1, val2) {
      this.dynamicValimarkForm.orderId = val1;
    },
  },
  mounted() {
    this.dynamicValimarkForm.orderId = this.orderId;
  },
  methods: {
    submitForm() {
      this.dynamicValimarkForm.remarks = "";
      this.stepLoading = true;
      this.$http.szOrder
        .editOrderRemarks(this.dynamicValimarkForm)
        .then((res) => {
          this.stepLoading = false;
          if (res.status == 1) {
            this.dialogVisible_remark = false;
            this.$message({
              message: "备注成功",
              type: "success",
            });
            this.$emit("closeStatus", true);
          }
        });
    },
    handleClose() {
      this.dialogVisible_remark = false;
      this.$emit("closeStatus", true);
    },
  },
};
